import React, { memo } from 'react'
import { areEqualProps } from '@dt/fe-utils'
import ListProductItem from './ListProductItem'
import WaterfallProductItem from './WaterfallProductItem'

// interface
type TProductItem = 'waterfall' | 'recommend' | 'classic' | 'list';
interface IProps {
  type?: TProductItem;
  product: IViewProduct;
  style?: any;
  count?: number;
  lazy?: boolean;
  wrapWidth?: number;
  backgroundMode?: 'light' | 'dark';
  imgLoaded?: boolean;
  size?: 'mini' | 'small' | 'default';
  mealDecorates?: TMealCommonDecorates;
}
// 瀑布流图片的宽度
const ProductItem: React.FC<IProps> = ({ type = 'waterfall', size = 'default', wrapWidth = 0, product, style, count, lazy = false, backgroundMode = 'light', imgLoaded = false, mealDecorates }) => {
  return type === 'waterfall' || type === 'recommend'
    ? <WaterfallProductItem wrapWidth={wrapWidth} size={size} decorate={mealDecorates} type={type} product={product} style={style} count={count} lazy={lazy} backgroundMode={backgroundMode} imgLoaded={imgLoaded} />
    : <ListProductItem decorate={mealDecorates} type={type} product={product} count={count} lazy={lazy} backgroundMode={backgroundMode} imgLoaded={imgLoaded} />
}

const areEqual = function (prevProps: IProps, nextProps: IProps) {
  return !!areEqualProps(prevProps, nextProps, [
    'count',
    'product.id',
    'product.soldout',
    'product.actualPrice',
    'product.soldout',
    'product.memberPrice',
    'product.offPrice',
    'product.isMemberDiscount',
    'imgLoaded',
    'style.left',
    'style.top',
    'mealDecorates'
  ])
}
export default memo(ProductItem, areEqual)
